import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getCurrentUrl } from './urls';
const checkLangCode = value => {
  return Object.values(Locale).includes(value);
};
export const getPreferredLocale = () => {
  const url = new URL(getCurrentUrl());
  let locale = Locale.en;
  if (url.searchParams.has('lang')) {
    const queryLang = url.searchParams.get('lang');
    const isLangLocaleSupported = checkLangCode(queryLang);
    if (isLangLocaleSupported) {
      locale = queryLang;
    } else {
      const lang = queryLang.split('-')[0];
      const isLangSupported = checkLangCode(lang);
      if (isLangSupported) {
        locale = lang;
      }
    }
  }
  return locale;
};